import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authService from "../../services/auth.service";
import adminService from "../../services/admin.service";

const user = JSON.parse(localStorage.getItem("user"));

const initialState = user
    ? {
          isLoggedIn: true,
          message: "",
          user: user,
      }
    : {
          isLoggedIn: false,
          message: "",
          user: null,
      };

export const registerAsync = createAsyncThunk("auth/register", async (user) => {
    const response = await authService.register(
        user.familyname,
        user.username,
        user.email,
        user.password,
        user.roles
    );
    // The value we return becomes the `fulfilled` action payload
    return response.data;
});

export const loginAsync = createAsyncThunk("auth/login", async (user) => {
    const response = await authService.login(
        user.familyname,
        user.username,
        user.password
    );
    // The value we return becomes the `fulfilled` action payload
    return response.data;
});

export const logout = () => (dispatch) => {
    authService.logout();
    dispatch(userLogout());
};

export const refreshAsync = createAsyncThunk("auth/refresh", async () => {
    const response = await authService.refresh();
    // The value we return becomes the `fulfilled` action payload
    return response.data;
});

export const addmemberAsync = createAsyncThunk("admin", async (member) => {
    const response = await adminService.create(
        // user.familyId,
        member.username,
        member.email,
        member.password,
        member.roles
    );
    // The value we return becomes the `fulfilled` action payload
    return response.data;
});

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        userLogout: (state) => {
            state.isLoggedIn = false;
            state.user = null;
        },
        setMessage: (state, action) => {
            state.message = action.payload;
        },
        clearMessage: (state) => {
            state.message = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(registerAsync.pending, (state) => {
                state.message = "REGISTER_PENDING";
            })
            .addCase(registerAsync.fulfilled, (state, action) => {
                state.isLoggedIn = false;
                state.message = "REGISTER_SUCCESS";
                state.user = null;
            })
            .addCase(registerAsync.rejected, (state) => {
                state.isLoggedIn = false;
                state.message = "REGISTER_FAIL";
                state.user = null;
            })
            .addCase(loginAsync.pending, (state) => {
                state.message = "LOGIN_PENDING";
            })
            .addCase(loginAsync.fulfilled, (state, action) => {
                state.isLoggedIn = true;
                state.message = "LOGIN_SUCCESS";
                state.user = action.payload;
            })
            .addCase(loginAsync.rejected, (state) => {
                state.isLoggedIn = false;
                state.message = "LOGIN_FAIL";
                state.user = null;
            })
            .addCase(refreshAsync.fulfilled, (state, action) => {
                state.isLoggedIn = true;
                state.message = "REFRESH_SUCCESS";
                state.user = action.payload;
            })
            .addCase(addmemberAsync.pending, (state) => {
                state.message = "ADD_MEMBER_PENDING";
            })
            .addCase(addmemberAsync.fulfilled, (state, action) => {
                // state.isLoggedIn = false;
                state.message = "ADD_MEMBER_SUCCESS";
                // state.user = null;
            })
            .addCase(addmemberAsync.rejected, (state) => {
                // state.isLoggedIn = false;
                state.message = "ADD_MEMBER_FAIL";
                // state.user = null;
            });
    },
});

export const { userLogout, setMessage, clearMessage } = authSlice.actions;

export const selectIsLoggedIn = (state) => state.auth.isLoggedIn;
export const selectUser = (state) => state.auth.user;
export const selectMessage = (state) => state.auth.message;

export default authSlice.reducer;
